import { INitrogenAnalysis, INitrogenAnalysisAlloc } from "../../../nitrogen/types"
import { ISoilService } from "../../../types"
import { IAnalysisLayerData } from "../map/analysis-layer"
import { IGlobalAllocationBindingModel } from "../types"
import { GlobalAnalysisAlloc } from "./alloc-vm"
import { GlobalAnalysisVM } from "./analysis-vm"
import { GlobalNitrogenAnalysisAlloc } from "./nitrogen-alloc-vm"

export class GlobalNitrogenAnalysisVM extends GlobalAnalysisVM {

    constructor(svc: ISoilService, analysis: INitrogenAnalysis) {
        super(analysis);

        if (this.nitrogenAnalysis.Allocations.length) {
            this.allocations = this.nitrogenAnalysis.Allocations
                .map(a => GlobalNitrogenAnalysisAlloc.createFromAlloc(svc, this, a));
        }
    }

    get nitrogenAnalysis(): INitrogenAnalysis {
        return <INitrogenAnalysis>this.analysis;
    }

    getAnalysisId(): number {
        return this.nitrogenAnalysis.NitrogenAnalysisId;
    }

    getDescription(): string {
        return this.nitrogenAnalysis.AnalysisNumber;
    }

    alloc(data: IAnalysisLayerData) {

        this.allocations.push(GlobalNitrogenAnalysisAlloc.createAlloc(this, data));

    }

    checkAllocationInDatas(allocation: GlobalAnalysisAlloc, datas: IAnalysisLayerData[]): boolean {

        var hsaAlloc = <GlobalNitrogenAnalysisAlloc>allocation;

        if (!allocation.shown) return true;

        return datas.filter(d => d.field.croppingId === hsaAlloc.cropping.croppingId).length > 0;

    }

    checkDataInAllocations(data: IAnalysisLayerData): boolean {

        return this.allocations.filter(a => (<GlobalNitrogenAnalysisAlloc>a).cropping.croppingId === data.field.croppingId).length > 0;

    }


    unallocFeature(data: IAnalysisLayerData) {

        this.allocations = this.allocations.filter(a => (<GlobalNitrogenAnalysisAlloc>a).cropping.croppingId !== data.field.croppingId);

    }

    getAllocationModels(): IGlobalAllocationBindingModel[] {

        return this.allocations.map(a => {
            var allocation = <GlobalNitrogenAnalysisAlloc>a;

            return <IGlobalAllocationBindingModel>{
                AnalysisId: this.nitrogenAnalysis.NitrogenAnalysisId,
                AllocationId: allocation.allocation ? (<INitrogenAnalysisAlloc>allocation.allocation).NitrogenAnalysisAllocId : null,
                FieldId: allocation.cropping.fieldId,
                CroppingId: allocation.cropping.croppingId
            };
        });

    }
}
